import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '../components/LoginPage.vue';
import Home from '../components/HomePage.vue';
import Invoices from '../components/invoices/InvoicesPage.vue';
import Plans from '../components/plans/PlansPage.vue';
import Reservations from '../components/reservations/ReservationsPage.vue';
import NewUser from '../components/users/NewUserPage.vue';
import Users from '../components/users/UsersPage.vue';
import UserDetails from '../components/users/UserDetailsPage.vue';
import Wallet from '../components/wallet/WalletPage.vue';
import Coupons from '../components/coupons/CouponsPage.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next('/home');
      } else {
        next();
      }
    }
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/reservations',
    name: 'Reservations',
    component: Reservations,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/plans',
    name: 'Plans',
    component: Plans,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/user/add',
    name: 'NewUser',
    component: NewUser,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/user/:userid',
    name: 'UserDetails',
    component: UserDetails,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: Wallet,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/coupons',
    name: 'Coupons',
    component: Coupons,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  }

];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
